import { render, staticRenderFns } from "./card.vue?vue&type=template&id=530b7d10&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"
import style0 from "./card.vue?vue&type=style&index=0&id=530b7d10&prod&scoped=true&lang=scss"
import style1 from "./card.vue?vue&type=style&index=1&id=530b7d10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530b7d10",
  null
  
)

export default component.exports